/**
 * Allow {@link ActionQueue} to automatically start the execution loop and pause
 * it when the queue is empty.
 * @packageDocumentation
 */

import { Scheduler, SchedulerInterface, SchedulerItemInterface } from '../Scheduler';
import { ActionQueue } from './ActionQueue';

let loop: SchedulerItemInterface<[]> | undefined;

export function startLoop(): void {
    //drive the action queue
    if (!loop) {
        loop = (Scheduler as SchedulerInterface)
            .New()
            .Called('runActionQueue')
            .HasAction(ActionQueue.Execute)
            .RunEvery(250, 'ms');
    } else if (!loop.Active) {
        loop.Resume();
    }
}

export function stopLoop(): void {
    if (loop) {
        loop.Pause();
    }
}

export function isLoopActive(): boolean {
    return Boolean(loop?.Active);
}
